import type { EmployeeExtended } from "./gen";

export const employeeStruct: EmployeeExtended = {
  address: {
    data_complete: false,
    address_supplement: "",
    city: "",
    country: "",
    province: "",
    street_name: "",
    street_number: "",
    zip_code: "",
    missing_fields: [],
  },
  app_settings: {
    do_onboarding: false,
  },
  benefit_budget: {
    betreuungskosten: 0,
    erholungsbeihilfe: 0,
    essenszuschuss: 0,
    fahrtkosten: 0,
    internetpauschale: 0,
    telefonkosten: 0,
    base_available_amount: 0,
    total_available_amount: 0,
    total_used_amount: 0,
    active_benefits: [],
    öpnv_tickets: 0,
    custom_legacy: [],
    bav: 0,
    mpp: 0,
    jobbike: 0,
    sachbezug: 0,
    bkv: 0,
    custom: [],
  },
  benefit_settings: {
    bav: {
      adjusted_monthly_maximum_amount: 0,
      active: false,
      desired: false,
      activated_at: "",
    },
    betreuungskosten: {
      adjusted_monthly_maximum_amount: 0,
      active: false,
      desired: false,
      activated_at: "",
    },
    erholungsbeihilfe: {
      adjusted_monthly_maximum_amount: 0,
      desired: false,
      active: false,
      activated_at: "",
    },
    essenszuschuss: {
      adjusted_monthly_maximum_amount: 0,
      active: false,
      desired: false,
      activated_at: "",
    },
    fahrtkosten: {
      adjusted_monthly_maximum_amount: 0,
      active: false,
      desired: false,
      activated_at: "",
    },
    internetpauschale: {
      adjusted_monthly_maximum_amount: 0,
      active: false,
      desired: false,
      activated_at: "",
    },
    jobbike: {
      adjusted_monthly_maximum_amount: 0,
      active: false,
      desired: false,
      activated_at: "",
    },
    mpp: {
      adjusted_monthly_maximum_amount: 0,
      active: false,
      desired: false,
      activated_at: "",
    },
    sachbezug: {
      adjusted_monthly_maximum_amount: 0,
      active: false,
      desired: false,
      activated_at: "",
      options: [],
    },
    telefonkosten: {
      adjusted_monthly_maximum_amount: 0,
      desired: false,
      activated_at: "",
    },
    öpnv_tickets: {
      adjusted_monthly_maximum_amount: 0,
      desired: false,
      activated_at: "",
    },
    bkv: {
      adjusted_monthly_maximum_amount: 0,
      desired: false,
      activated_at: "",
    },
  },
  contact_data: {
    email: "",
    missing_fields: [],
  },
  general_data: {
    birth_date: "",
    birth_last_name: "",
    first_name: "",
    gender: "undefined",
    last_name: "",
    marriage_status: "ledig",
    nationality: "",
    profile_picture: {
      name: "",
      size: 0,
      url: "",
    },
    missing_fields: [],
  },
  id: "",
  position_data: {
    cost_center: "",
    department: "",
    location: "",
    employee_number: "",
    entry_date: "",
    exit_date: "",
    note: "",
    position_name: "",
    working_days_per_week: 0,
    working_hours_per_week: 0,
    missing_fields: [],
  },
  tax_data: {
    children_count: 0,
    kinderfreibetrag: 0,
    religion: false,
    steuerklasse: 0,
    missing_fields: [],
  },
  user: {
    email: "",
    email_origin: "work",
  },
  cost_center: "",
  department: "",
  location: "",
  status: "INACTIVE",
  has_notifications: false,
  groups: [],
  next_month_benefit_set: { name: "", enabled_benefits: [] },
  upcoming_benefit_sets: [],
};
